export class SubscriberProductPriceTierModel {
	id?: number = undefined;
	idPrice?: number = undefined;
	start: number = 0;
	end: number = 0;
	value: number = 0;

	constructor(s?:Partial<SubscriberProductPriceTierModel>) {
		Object.assign(this, s)		
	}
}
